module.exports = __webpack_public_path__ + "img/179952.8e8a3f9a.png";